
import React from 'react'
import { useSelector } from 'react-redux'

import navigation from '@/navigation'

import Header from '@/Layouts/MainLayout/components/Header'
import HeaderSubMenu from '@/Layouts/MainLayout/components/HeaderSubMenu'
import MainSidebar from '@/Layouts/MainLayout/components/MainSidebar'

import '@/Layouts/MainLayout/MainLayout.scss'

interface Props {
  menuName: string
  subMenuName?: string
  projectId?: string
  className?: string
  children: any
}

const MainLayout = ({projectId, menuName, subMenuName, className, children }: Props) => {

  const projectsData = useSelector((state: any) => state.ProjectsReducer.data)
  const availableProjects = [
    ...(projectsData?.mine || []),
    ...(projectsData?.other || []),
    ...(projectsData?.active || []),
  ]
  const selectedProject = projectId
    ? availableProjects.find((project: any) => project._id === projectId)
    : undefined
  const navigationProjectId = projectId || ''

  const [ menu, submenu ] = navigation.getNavigation(
    navigationProjectId,
    menuName,
    subMenuName || '',
  )

  return (
    <div className={`main-layout app-admin-wrap layout-horizontal-bar ${className || ''}`}>
      <Header menu={menu} selectedProject={selectedProject} />
      <div className="pl4-shell-workspace">
        <MainSidebar menu={menu} />
        <div className="pl4-shell-main">
          <HeaderSubMenu submenu={submenu} />
          <div className="main-content-wrap d-flex flex-column">
            <div className="main-content-shadow" />
            <div className="main-content">
              <div className="page-content-body">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainLayout
